if (!customElements.get('collection-pagination')) {
  class CollectionPagination extends HTMLElement {
    constructor() {
      super();

      this.gridContainer = document.querySelector('#product-grid');
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      this.querySelector('[data-infinite-load]')?.addEventListener(
        'click',
        (event) => {
          this.enableInfiniteLoad();

          event.preventDefault();
        },
      );
    }

    enableInfiniteLoad() {
      this.classList.add('infinite-load');

      this.loadResources(
        this.querySelector('[data-next-btn]').getAttribute('href'),
      );

      window.addEventListener('scroll', () => {
        if (
          window.scrollY + window.innerHeight >= this.offsetTop &&
          !this.classList.contains('is-loading') &&
          this.querySelector('[data-next-btn]')
        ) {
          this.loadResources(
            this.querySelector('[data-next-btn]').getAttribute('href'),
          );
        }
      });
    }

    loadResources(url) {
      this.classList.add('is-loading');

      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const parsedHTML = new DOMParser().parseFromString(
            responseText,
            'text/html',
          );

          this.appendResources(parsedHTML);

          this.updatePagination(parsedHTML);

          this.classList.remove('is-loading');
        })
        .catch((e) => {
          this.classList.remove('is-loading');

          console.error(e);
        });
    }

    appendResources(html) {
      const gridItems = html.querySelectorAll('#product-grid [data-grid-item]');

      gridItems.forEach((item) => {
        this.gridContainer.append(item);
      });
    }

    updatePagination(html) {
      const pagination = html.querySelector('collection-pagination');

      this.innerHTML = pagination.innerHTML;
    }
  }

  customElements.define('collection-pagination', CollectionPagination);
}
